import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ProductDetailViewModel } from '@models/api-search.models';
import { ProductSplashType } from '@features/product/product.models';
import { GetPrioritySplashPipe } from '../pipes/get-priority-splash.pipe';
import { FirstSplashPipe } from '../pipes/first-splash.pipe';
import { SameDayDeliveryPipe } from '@features/product/pipes/same-day-delivery.pipe';
import { ColorStringToHexPipe } from '@shared/product-details-pipes/color-string-to-hex.pipe';
import { ProductSplashComponent } from '../product-splash/product-splash.component';
import { AsyncPipe, NgIf } from '@angular/common';
import { ActiveSplashPipe } from '@features/product/pipes/active-splash.pipe';
import { TranslateSafePipe } from '@shared/translate-safe/translate-safe.pipe';

@Component({
    selector: 'app-product-splashes',
    templateUrl: './product-splashes.component.html',
    styleUrls: ['./product-splashes.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
    NgIf,
    ProductSplashComponent,
    AsyncPipe,
    ColorStringToHexPipe,
    SameDayDeliveryPipe,
    FirstSplashPipe,
    GetPrioritySplashPipe,
    ActiveSplashPipe,
    TranslateSafePipe
]
})
export class ProductSplashesComponent {
    compressed = input<boolean>();
    product = input.required<ProductDetailViewModel>();
    displayCampaigns = input<boolean | undefined>();
    type = input<ProductSplashType>('statement');
}
